import React from "react";
import Varient1 from "./Varient1";
import Varient2 from "./Varient2";

const CoBrandedFooterBanner = ({ footerBannerData }: any) => {
  return (
    <div>
      {(footerBannerData?.varient === "primary" ||
        footerBannerData?.varient === 1) && <Varient1 {...footerBannerData} />}
      {(footerBannerData?.varient === "secondry" ||
        footerBannerData?.varient === 2) && <Varient2 {...footerBannerData} />}
    </div>
  );
};

export default CoBrandedFooterBanner;
